(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-backto"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const backButton = document.querySelector('.fs-back-button');
  
  if (backButton) {
    backButton.addEventListener('click', function(event) {
      if (document.referrer && window.history.length > 1) {
        event.preventDefault(); 
        window.history.back();  
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-countdown-section"] && !Shopify.designMode) return;
  try {
    
    class CountdownSection extends HTMLElement {
    constructor() {
        super();
    }

    init() {
        this.schemaTime = this.getAttribute('schema-time');
        this.timer = this.querySelector(".timer")
        this.countdown = new Date(this.schemaTime).getTime();
        this.second = 1000;
        this.minute = this.second * 60;
        this.hour = this.minute * 60;
        this.day = this.hour * 24;

        this.timerInterval = null;
        this.startTimer();

        setTimeout(() => this.timer.style.visibility = "visible", 1000)
    }

    startTimer() {
        const fsSectionTimer = document.querySelector(".fs-section-timer");
        const timerElem = this.timer;

        this.timerInterval = setInterval(() => {
            const now = new Date().getTime();
            const distance = this.countdown - now;

            const dayCalc = Math.floor(distance / this.day);
            const hourCalc = Math.floor((distance % this.day) / this.hour);
            const minuteCalc = Math.floor((distance % this.hour) / this.minute);
            const secondCalc = Math.floor((distance % this.minute) / this.second);

            timerElem.querySelector('.js-timer-days').textContent = dayCalc.toString().padStart(2, '0');
            timerElem.querySelector('.js-timer-hours').textContent = hourCalc.toString().padStart(2, '0');
            timerElem.querySelector('.js-timer-minutes').textContent = minuteCalc.toString().padStart(2, '0');
            timerElem.querySelector('.js-timer-seconds').textContent = secondCalc.toString().padStart(2, '0');
        
            if (distance < 0) {
			clearInterval(this.timerInterval);
			fsSectionTimer.remove();
			}
        }, 1000);

    }

    disconnectedCallback() {
        clearInterval(this.timerInterval);
    }

    connectedCallback(){
        this.init();
        console.log("countdown timer was added to the page")
        
  
    }
	disconnectedCallback(){
        console.log("The Timer date has passed so the timer was removed")
    }
}


    customElements.define('countdown-section', CountdownSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
